











































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'


import ProductResourceItem1ProductDescription from './service-for-product-resource-item/product-resource-item-1-product-description.vue'
import ProductResourceItem2ProductStatistics from './service-for-product-resource-item/product-resource-item-2-product-statistics.vue'
import ProductResourceItem3ProductComments from './service-for-product-resource-item/product-resource-item-3-product-comments.vue'


@Component({
  components: {
    ProductResourceItem1ProductDescription,
    ProductResourceItem2ProductStatistics,
    ProductResourceItem3ProductComments
  }
})
class ProductResourceHelperComponents3ResourceList extends Vue {
  @Prop({ default: '' }) productResourceId?: string

  isExandedPanelList: number[] = []

  isOpenAccountDescription: number = 0
  isOpenAccountStatistics: number = 0
  isOpenTransactionStatistics: number = 0
}

export default ProductResourceHelperComponents3ResourceList

